<script>
export default {
  name: "DeviceCorrectionForm",
  props: {
    gain: { type: Number, default: () => 0 },
    offset: { type: Number, default: () => 0 },
  },
  data() {
    return {
      form: {
        gain: 0,
        offset: 0,
      },
    };
  },
  watch: {
    gain: {
      handler: function() {
        this.form.gain = this.gain;
      },
      immediate: true,
    },
    offset: {
      handler: function() {
        this.form.offset = this.offset;
      },
      immediate: true,
    },
  },
};
</script>

<template>
  <v-form @input="$emit('update', form)">
    <v-container>
      <v-row>
        <span class="subtitle-1">デバイス固有のゲインとオフセット値</span>
        <v-col cols="12" class="my-0 py-0">
          <v-text-field
            label="ゲイン"
            class="corr_gain"
            :value="form.gain"
            @input="form.gain = +$event"
          />
        </v-col>
        <v-col cols="12" class="my-0 py-0">
          <v-text-field
            label="オフセット"
            class="corr_offset"
            :value="form.offset"
            @input="form.offset = +$event"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>
